import { memo } from 'react'
import BasePopconfirm from '@/components/BasePopconfirm/BasePopconfirm'
import './BaseStep.less'
const BaseStep = ({ step, list, onConfirm, payment_state, type, style = {} }: any) => {
  return (
    <ul className={`BaseStep-container`}>
      {list.map((item: any, index: number) => {
        const isActive = step > index
        const currentStep = index + 1
        const isCurrentStep = step === index + 1
        const isLastStep = list.length == step
        const labelContent = step - 1 <= index ? <i>{index + 1}</i> : <i className='icon-duigou' />
        return (
          <li key={index}>
            {isCurrentStep ? (
              <label className={isActive ? 'active' : ''} style={isActive ? style : {}}>
                {labelContent}
              </label>
            ) : (list.length == step && type != 5) || (list.length == step && type == 5 && payment_state == 1) ? (
              <BasePopconfirm
                disabled={step <= index}
                className={'lastStep'}
                popconfirmProps={{
                  title: '作品已完成，不支持返回'
                }}
              >
                <label className={isActive ? 'active' : ''} style={isActive ? style : {}}>
                  {labelContent}
                </label>
              </BasePopconfirm>
            ) : (
              <BasePopconfirm
                disabled={step <= index}
                popconfirmProps={{
                  title: '返回步骤',
                  description: '后续步骤数据将被清除，是否返回？',
                  onConfirm: () => onConfirm(currentStep, isLastStep)
                }}
              >
                <label className={isActive ? 'active' : ''} style={isActive ? style : {}}>
                  {labelContent}
                </label>
              </BasePopconfirm>
            )}
            {item.label}
          </li>
        )
      })}
    </ul>
  )
}

export default memo(BaseStep)
